import { render, staticRenderFns } from "./wagesSettings.vue?vue&type=template&id=e4059030&scoped=true&"
import script from "./wagesSettings.vue?vue&type=script&lang=js&"
export * from "./wagesSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4059030",
  null
  
)

export default component.exports